import {
    EnumArrayComboboxFilter,
    EnumArrayComboboxFilterResult,
    EnumComboboxFilter,
    EnumComboboxFilterResult,
} from "../../components/filters/ComboboxFilter";
import { NumberRangeFilter, NumberRangeFilterResult } from "../../components/filters/NumberRangeFilter";
import {
    RelativeDateRangeFilter,
    RelativeDateRangeFilterResult,
} from "../../components/filters/RelativeDateRangeFilter";
import type { WidgetViewPair } from "../../services/dynamic-filters-adapter/types";
import { dynamicFilterWidgetMap } from "../../types/dynamicFieldDescriptor";

type DynamicFilterWidget = (typeof dynamicFilterWidgetMap)[keyof typeof dynamicFilterWidgetMap];

export const WIDGET_VIEWS = {
    [dynamicFilterWidgetMap.enumCombobox]: { view: EnumComboboxFilter, resultView: EnumComboboxFilterResult },
    [dynamicFilterWidgetMap.enumArrayCombobox]: {
        view: EnumArrayComboboxFilter,
        resultView: EnumArrayComboboxFilterResult,
    },
    [dynamicFilterWidgetMap.relativeDateRange]: {
        view: RelativeDateRangeFilter,
        resultView: RelativeDateRangeFilterResult,
    },
    [dynamicFilterWidgetMap.numberRange]: {
        view: NumberRangeFilter,
        resultView: NumberRangeFilterResult,
    },
} satisfies Record<DynamicFilterWidget, WidgetViewPair>;
